import { Box, Flex, Text, Collapse } from "@chakra-ui/react";
import { useState, memo } from "react";
import colors from "core/resources/theme/colors";
import { BiChevronDown, BiChevronRight } from "react-icons/bi";
import { formatMoney } from "infra/helpers/number";

export interface ItemResumoProps {
  table: React.ReactNode;
  title: string;
  total?: number;
  bg?: string;
  mt?: string;
}

function ItemResumo({
  table,
  total,
  title,
  bg = colors.lightBlue,
  mt = "1px",
}: ItemResumoProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen((state) => !state);
  return (
    <Box w="100%">
      <Flex
        cursor="pointer"
        bg={bg}
        onClick={toggle}
        py={1}
        px={8}
        alignItems="center"
        justifyContent="space-between"
        borderTop={`1px solid #EBEBEB `}
        mt={mt}
      >
        <Flex alignItems="center" h="40px">
          <Flex ml={-1}>
            {isOpen ? (
              <BiChevronDown size={25} color={colors.black700} />
            ) : (
              <BiChevronRight size={25} color={colors.black700} />
            )}
          </Flex>
          <Text ml={1} fontWeight="medium" fontSize="16px">
            {title}
          </Text>
        </Flex>

        {total ? (
          <Text fontWeight="medium" fontSize="16px" textAlign="right" ml="auto">
            {formatMoney(total)}
          </Text>
        ) : null}
      </Flex>
      <Collapse in={isOpen}>
        <Box>{table}</Box>
      </Collapse>
    </Box>
  );
}

export default memo(ItemResumo);
